<div class="snackbar-content">
  <span
    class="queue-position"
    [class.queue-position_visible]="
      (snackbarService.messageCallsQueueLength$ | async)! > 1
    "
    >{{
      data.queuePosition +
        " of " +
        (snackbarService.messageCallsQueueLength$ | async)
    }}</span
  >
  <ng-lottie
    *ngIf="lottieAnimations[data.type]"
    class="lottie-player"
    [options]="lottieAnimations[data.type]"
  ></ng-lottie>
  <span class="message">{{ data.message }}</span>
  <button
    class="dismiss dismiss-{{ data.type }}"
    type="button"
    (click)="dismiss($event)"
  >
    <div class="dismiss-content">
      {{ dismissText }}
    </div>
  </button>
</div>
